module.exports = __webpack_public_path__ + "static/media/luciana_de_abreu_aquino.d6c0c97f.png";